import { useAppSelector } from "../../../redux/store";
import { Card, Grid, Section } from "../../../ui";
import PortalHero from "../../../components/PortalHero";

/**
 * The office's landing page. The old Dashboard nav item had no index route,
 * so the first item in the sidebar opened an empty frame. This is the front
 * door: the same areas as the nav, with a sentence about what each holds.
 */
export default function DashboardHome() {
  const { user } = useAppSelector((state) => state.login);
  const permissions = user?.permissions || {};
  const isSuper = user?.role === "super-admin";
  const firstName = user?.username?.split(" ")[0];

  return (
    <>
      <PortalHero
        width="full"
        eyebrow="Overview"
        title={firstName ? `Dashboard, ${firstName}` : "Dashboard"}
        summary="The office at a glance: billing, vendors, documents and access."
      />

      <Section title="Billing">
        <Grid cols={3}>
          <Card
            to="/dashboard/customers"
            title="Customers"
            footer="Companies, contacts and billing addresses"
          >
            The companies the office bills, and who can pay for them.
          </Card>
          <Card
            to="/dashboard/invoices"
            title="Invoices"
            footer="Balances and payment links"
          >
            Every invoice in the active book, its balance, and its link.
          </Card>
          <Card
            to="/dashboard/client-overview"
            title="Client Overview"
            footer="Logins and preferred payment"
          >
            Who can sign in for each client, and how they pay.
          </Card>
        </Grid>
      </Section>

      {(permissions["lien waiver"] || permissions["vendors"] || isSuper) && (
        <Section title="Vendors">
          <Grid cols={3}>
            {(permissions["lien waiver"] || isSuper) && (
              <Card
                to="/dashboard/lien-waivers"
                    title="Lien Waivers"
                footer="Notices and payment status"
              >
                Who is owed money, which notices went out, and who still needs one.
              </Card>
            )}
            {(permissions["vendors"] || isSuper) && (
              <Card
                to="/dashboard/vendor-audit"
                    title="Vendor Audit"
                footer="Certificates and Dropbox folders"
              >
                Every vendor in the Intuit book, their insurance, and their folder.
              </Card>
            )}
          </Grid>
        </Section>
      )}

      <Section title="Workspace">
        <Grid cols={3}>
          <Card
            to="/dashboard/dropbox-folders"
            title="Dropbox Folders"
            footer="Job folders and project links"
          >
            The folders the office shares with clients.
          </Card>
          <Card
            to="/dashboard/users"
            title="Users"
            footer="Everyone who can sign in"
          >
            People, roles and the projects assigned to them.
          </Card>
          {(permissions["integrations"] || isSuper) && (
            <Card
              to="/dashboard/integrations"
                title="Integrations"
              footer="Accounting books and Intuit"
            >
              The books the portal reads and the realm it syncs.
            </Card>
          )}
        </Grid>
      </Section>
    </>
  );
}
